import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SocketProvider } from '../../providers/socket/socket';

@Component({
  selector: 'page-final',
  templateUrl: 'final.html'
})
export class FinalPage {
  background;
  constructor(public navCtrl: NavController, private socketProvider: SocketProvider) {
    this.background = '../../assets/imgs/background/' + this.socketProvider.getRandomBackground();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/final/final.ts